import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "partition-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_dropdown_item = _resolveComponent("app-dropdown-item");
  return _openBlock(), _createBlock(_component_app_dropdown_item, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")])]),
    _: 3
  });
}